import api from './api';

export const REVIEWS_SET_TOTAL = 'REVIEWS_SET_TOTAL';

// Reviews may only be left within this many months of the order being paid.
export const REVIEW_WINDOW_MONTHS = 6;

// Whether an order is still inside its review window, measured from the paid
// timestamp (paidAt / checkoutCompletedAt). Fails closed when the timestamp is
// absent — the order API must serialize it for the window to be evaluated.
export function isReviewWindowOpen(order) {
  const paidAt = order && (order.paidAt || order.checkoutCompletedAt);

  if (!paidAt) {
    return false;
  }

  const deadline = new Date(paidAt);
  deadline.setMonth(deadline.getMonth() + REVIEW_WINDOW_MONTHS);

  return Date.now() <= deadline.getTime();
}

// The backend product-reviews endpoint exposes per-review ratings + a total
// count, but no aggregate average. We display a fixed headline rating (the
// number the site has always advertised) and source only the count from the API.
export const REVIEWS_AVERAGE_RATING = '4.9';

export default function reducer(state = {}, {type, payload}) {
  switch (type) {
    case REVIEWS_SET_TOTAL:
      return {
        ...state,
        total: payload,
      };
    default:
      return state;
  }
}

export function setReviewsTotal(total) {
  return {type: REVIEWS_SET_TOTAL, payload: total};
}

// Fetch a page of accepted product reviews from the backend.
// params: {productCode, taxonCode, ratingOrder, page, limit}
// Resolves with the raw api response ({content: {items}, meta: {page, pages, total, ...}}).
export function fetchReviews(params = {}) {
  return api.get('product-reviews/', params, {cache: 'default'});
}

// Fetch the accepted product reviews submitted for a single order, keyed by
// product code so the review page can render already-reviewed products. The
// endpoint is token-authorised (the order token lives in the path) and returns
// a plain JSON array — unknown/empty tokens simply resolve to []. Freshly
// created reviews are pending moderation and therefore absent here, so the page
// keeps its own just-submitted reviews in local state.
export function fetchOrderReviews(orderToken) {
  return (dispatch) =>
    dispatch(api.get(`orders/by-token/${orderToken}/reviews`))
      .then((response) => response.content);
}

// Create a single product review for one product in a paid order.
// review: {orderToken, productCode, rating, comment, publicName?}
// Resolves with the created review ({rating, publicName, comment, reply, createdAt}).
export function createProductReview(review) {
  return (dispatch) =>
    dispatch(api.post('product-reviews/', review)).then((response) => response.content);
}

// Fetch just the total accepted-review count (single-item page, read meta.total).
export function fetchReviewsTotal() {
  return (dispatch) => {
    dispatch(setReviewsTotal(null));

    return dispatch(fetchReviews({limit: 1})).then(
      (response) => dispatch(setReviewsTotal(response.meta.total)),
      () => dispatch(setReviewsTotal(null))
    );
  };
}



// WEBPACK FOOTER //
// ./ducks/reviews.js